import { cn } from "@/lib/utils";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

type Props = {
    streak: number;
    // 이 값이 변경될 때 토스트를 표시
    triggerKey: string | null;
};

/**
 * 🔥 스트릭 달성 토스트 알림.
 * triggerKey가 변경되면 2.5초 동안 표시 후 자동으로 사라짐.
 */
export const StreakToast = ({ streak, triggerKey }: Props) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!triggerKey || streak <= 0) return;

        setVisible(true);
        const timer = setTimeout(() => setVisible(false), 2500);
        return () => clearTimeout(timer);
    }, [triggerKey]);

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 24 }}
                    transition={{ duration: 0.25 }}
                    className={cn(
                        "fixed bottom-6 left-1/2 z-[200] -translate-x-1/2",
                        "rounded-full bg-orange-500 px-5 py-2.5 shadow-lg",
                        "text-sm font-semibold text-white"
                    )}
                >
                    🔥 {streak}일 연속 달성!
                </motion.div>
            )}
        </AnimatePresence>
    );
};
